


























import { Vue, Component, Prop } from 'vue-property-decorator';
import SelectionComponent from '@/shared/fields/selection.componet.vue';
import LabelSlot from '@/shared/slots/label-slot.component.vue';
import DrdService from '@/domain/drd/service/drd.service';
import Assignment from '@/domain/drd/entity/assignment.entity';

@Component({
  components: {
    SelectionComponent,
    LabelSlot,
  },
})
export default class AssignmentSingleFilter extends Vue {
  @Prop({
    type: String,
    default: 'Papel',
  }) label!: string;

  @Prop({
    type: String,
    default: 'Digite o nome...',
  }) placeholder!: string;

  @Prop({
    type: String,
    default: 'Nenhum papel foi encontrado...',
  }) noDataText!: string;

  @Prop({
    type: Boolean,
    default: false,
  }) returnObject!: boolean;

  @Prop() assignmentsSelected!: any;

  @Prop({
    default: () => null,
  }) containsDRD!: boolean | null;

  @Prop({
    type: Boolean,
    default: true,
  }) clearable!: boolean;

  @Prop({
    type: Boolean,
    default: false,
  }) fetchAllOnInit!: boolean;

  foundAssignments: Assignment[] = [];

  loading: boolean = false;

  lastFilterAssignment: string = '';

  assignmentName: string = '';

  created() {
    this.handleFindAssignments('');
  }

  selected() {
    this.$emit('selected', this.assignmentsSelected);
  }

  handleFindAssignments(value: string) {
    if (this.fetchAllOnInit) {
      this.loading = true;
      DrdService.getAssigments('', this.containsDRD)
        .then(data => this.foundAssignments = data)
        .finally(() => this.loading = false);
      return;
    }
    this.findAssignments(value);
  }

  private debounceTimeout: number | null = null;

  findAssignments(value: string) {
    if (this.fetchAllOnInit) return;
    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = window.setTimeout(() => {
      if ((this.lastFilterAssignment !== value) && value) {
        this.lastFilterAssignment = value;
        if (value.length > 2) {
          this.loading = true;
          DrdService.getAssigments(value, this.containsDRD)
            .then(data => this.foundAssignments = data)
            .finally(() => {
              this.loading = false;
            });
        }
      }
    }, 1000);
  }
}
